import { render, staticRenderFns } from "./ManageTemplate.vue?vue&type=template&id=4bae6ece"
import script from "./ManageTemplate.vue?vue&type=script&lang=js"
export * from "./ManageTemplate.vue?vue&type=script&lang=js"
import style0 from "./ManageTemplate.vue?vue&type=style&index=0&id=4bae6ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports